import { render, staticRenderFns } from "./u-empty.vue?vue&type=template&id=6938e513&scoped=true&"
import script from "./u-empty.vue?vue&type=script&lang=js&"
export * from "./u-empty.vue?vue&type=script&lang=js&"
import style0 from "./u-empty.vue?vue&type=style&index=0&id=6938e513&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6938e513",
  null
  
)

component.options.__file = "node_modules/uview-ui/components/u-empty/u-empty.vue"
export default component.exports